import { render, staticRenderFns } from "./Guides.vue?vue&type=template&id=95195b84&scoped=true&"
import script from "./Guides.vue?vue&type=script&lang=js&"
export * from "./Guides.vue?vue&type=script&lang=js&"
import style0 from "./Guides.vue?vue&type=style&index=0&id=95195b84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95195b84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
